import { Component } from '@angular/core';
import { StatisticService } from './statistic.service';
import { ConfirmService } from '../shared/confirm/confirm.service';
import { AppService } from '../app.service';
import { AuthenticationService } from '../auth';

@Component({
    selector: 'statistic-comp',
    providers: [StatisticService, ConfirmService, AppService], 
    templateUrl: './statistic.component.html',  
    styleUrls: ['./statistic.component.css']  
})

export class StatisticComponent {   
  
    private activeComponent: boolean;

    constructor(
        private service: StatisticService,          
        private confirmService: ConfirmService,
        private appService: AppService,
        private authService: AuthenticationService) {
          this.authService.isAuthenticated();
          this.activeComponent = appService.isComponentActive('statistic');
        }
}